import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import has from 'lodash/has'
import isNull from 'lodash/isNull'

import { BASE_URL } from '../consts'
import { makeEdgeHeaders, makeAuthorizedEdgeHeaders } from './headers'

export const unAuthorizedConfigUploadFetch = axios.create({
  baseURL: BASE_URL,
  headers: makeEdgeHeaders(),
})

export interface ConfigUploadAuthorizeParams {
  token: string
  secretKey: string
  onUnauthorized: () => void
}

export let authorizedConfigUploadFetch: AxiosInstance =
  unAuthorizedConfigUploadFetch

export const authorizeConfigUploadAxios = ({
  token,
  secretKey,
  onUnauthorized,
}: ConfigUploadAuthorizeParams): AxiosInstance => {
  authorizedConfigUploadFetch = axios.create({
    baseURL: BASE_URL,
    headers: {
      ...makeAuthorizedEdgeHeaders(token, secretKey),
    },
  })

  authorizedConfigUploadFetch.interceptors.response.use(
    (response: AxiosResponse) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return has(response.data, 'error') && !isNull(response.data.error)
        ? Promise.reject(response.data.error)
        : response
    },
    (error: AxiosError) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response?.status === 401) {
        onUnauthorized()
      }

      return Promise.reject(error)
    }
  )

  return authorizedConfigUploadFetch
}

export const unauthorizeUploadAxios = (): AxiosInstance => {
  authorizedConfigUploadFetch = unAuthorizedConfigUploadFetch
  return authorizedConfigUploadFetch
}
